import React from 'react';
import { STextArea } from './style';

const TextArea = props => {
    return(
        <STextArea {...props}/>
    )
}
export default TextArea